import { createTheme } from '@mui/material/styles'
import { COLORS } from './constants'

const fontFamily = `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif`

const theme = createTheme({
    palette: {
        mode: 'light',
        primary: { main: COLORS.accent, contrastText: COLORS.black },
        secondary: { main: COLORS.black, contrastText: COLORS.white },
        text: { primary: COLORS.black, secondary: '#4B5260' },
        background: { default: COLORS.white, paper: COLORS.white },
        divider: COLORS.border,
    },
    shape: { borderRadius: 10 },
    typography: {
        fontFamily,
        h1: { fontSize: 'clamp(2.25rem, 5vw + 0.5rem, 3.75rem)', fontWeight: 800, lineHeight: 1.08, letterSpacing: '-0.02em' },
        h2: { fontSize: 'clamp(1.75rem, 3vw + 0.5rem, 2.5rem)', fontWeight: 800, lineHeight: 1.15, letterSpacing: '-0.015em' },
        h3: { fontSize: 'clamp(1.25rem, 1.5vw + 0.75rem, 1.6rem)', fontWeight: 700, lineHeight: 1.25 },
        h4: { fontSize: '1.2rem', fontWeight: 700, lineHeight: 1.3 },
        h5: { fontSize: '1.05rem', fontWeight: 700, lineHeight: 1.35 },
        h6: { fontSize: '0.95rem', fontWeight: 700 },
        body1: { fontSize: '1.0625rem', lineHeight: 1.65 },
        body2: { fontSize: '0.975rem', lineHeight: 1.6 },
        overline: { fontSize: '0.78rem', fontWeight: 600, letterSpacing: '0.16em', lineHeight: 1.6 },
        button: { textTransform: 'none', fontWeight: 600, fontSize: '1rem' },
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: { backgroundColor: COLORS.white, WebkitFontSmoothing: 'antialiased' },
                '::selection': { backgroundColor: COLORS.accent, color: COLORS.black },
            },
        },
        MuiButton: {
            defaultProps: { disableElevation: true },
            styleOverrides: {
                root: { borderRadius: 999, padding: '12px 24px' },
                sizeSmall: { padding: '7px 16px', fontSize: '0.9rem' },
            },
        },
        MuiTextField: { defaultProps: { variant: 'outlined', fullWidth: true } },
        MuiLink: { defaultProps: { underline: 'hover' } },
    },
})

export default theme
